import { getConfig } from '@/app/config'
import type { GlobalWidget } from '@/app/widgets'

/**
 * The AI mode in the classic layout (owner, 2026-10-27 — docs/ai-mode/PLAN.md): the assistant's pill and panel
 * (src/modules/assistant) carry this module's chat, and its canvas takes the page's place. A global widget, so the
 * conversation survives navigation; it registers itself with the assistant store (`setSurface`) and renders the
 * canvas. Beta flag, Clients and Staff — the users the assistant widget shows to.
 */
const widgets: GlobalWidget[] = [
  {
    id: 'ai-assistant',
    load: () => import('./surface/AiAssistantSurface.vue'),
    when: ({ signedIn, userType }) =>
      signedIn && getConfig().betaFeature && (userType === 'Client' || userType === 'Staff'),
  },
]

export default widgets
